/* eslint-disable no-console */
/* eslint-disable consistent-return */
/* eslint-disable react/prop-types */
import React from 'react'
import Modal from 'react-modal'
import { Button, ConfigProvider, Popconfirm, Spin } from 'antd'
import { CloseOutlined } from '@ant-design/icons'

import styled from 'styled-components'
import { useTranslation } from 'react-i18next'

const customStyles = {
  overlay: {
    willChange: 'backdrop-filter',
    background: 'rgba(0, 0, 0, 0.3)',
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
    zIndex: 1000
  }
}

export const HeaderContentStyled = styled.div`
  height: 36px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0;
  justify-content: center;
  text-transform: uppercase;

  font-weight: 700;
  font-size: 20px;
  line-height: 20px;

  color: ${({ theme }) => theme.black};
`

const ModalWrapper = styled(Modal)`
  box-sizing: border-box;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  line-height: 1.5715;
  list-style: 'none';
  font-feature-settings: 'tnum', 'tnum';
  pointer-events: none;
  position: relative;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: ${({ modalWith }) => modalWith}px;
  width: 100%;

  .ant-modal-close {
    position: absolute;
    right: 7px;
    top: 17.5px;
  }

  .ant-modal-close-x {
    width: auto;
    height: auto;

    font-weight: 400;
    font-size: 12px;
    line-height: 20px;

    color: #000000;
  }

  .anticon {
    display: flex;
    align-items: center;
  }

  .ant-modal-content {
    background: ${({ theme }) => theme.white};
    border-radius: 10px;

    .ant-modal-header {
      background-color: unset;
      padding: 6px 0 27px;
      text-align: center;
      border: none;
    }

    .ant-modal-body {
      overflow-x: ${(theme) => theme.overflow || 'auto'};
    }

    .ant-modal-footer {
      display: flex;
      justify-content: space-between;
      border: none;

      .button__cancel {
        margin-right: 10px;
      }

      &.no-cancel-button {
        justify-content: center;

        button {
          min-width: 108px;
        }
      }
    }
  }

  // &.light {
  //   .ant-modal-content {
    //     background: ${({ theme }) => theme.white};
  //
  //     .ant-modal-header {
    //       background: ${({ theme }) => theme.white};
  //     }
  //   }
  // }


  &.dark {
    color: ${({ theme }) => theme.white};

    ${HeaderContentStyled} {
      color: ${({ theme }) => theme.white};
    }

    .ant-modal-content {
      background: rgba(0, 0, 0, 0.71);
    }

    .ant-modal-close {
      span {
        color: ${({ theme }) => theme.white};

        &:first-child {
          display: none;
        }
      }
    }
  }
`

const Error = styled.div`
  background-color: ${({ theme }) => theme.bg_error};
  border: 1px solid ${({ theme }) => theme.bd_error};
  padding: 8px 16px;
`

const ButtonModal = styled(Button)`
  &.ant-btn {
    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 5px;
    height: 40px;
    width: auto;
    font-weight: 700;
    font-size: 12px;

    color: #FFFFFF;
  }
`

const ModalComponent = ({
  title,
  visible,
  onCancel,
  children,
  onSubmit,
  disabledSubmit,
  onSubmitText,
  onCancelText,
  showCloseText = true,
  showCloseButton = true,
  type,
  confirm = false,
  overlay = true,
  cancel = true,
  submit = true,
  loadingSubmit = false,
  isLoadingSubmit,
  confirmTitle = 'Are you sure to do this task?',
  isNotFooterButton = false,
  onClose,
  themeMode,
  modalWith = 287,
  ...rest
}) => {
  const { t } = useTranslation()
  const renderModalBodyBaseOnType = () => {
    switch (type) {
      case 'error':
        return <Error>{children}</Error>
      default:
        return children
    }
  }

  const renderButtonSubmit = () => {
    if (confirm) {
      return (
        <div id="modal-confirm-popup-container">
          <ConfigProvider getPopupContainer={() => document.getElementById('modal-confirm-popup-container')}>
            <Popconfirm
              title={confirmTitle}
              onConfirm={() => onSubmit()}
              okText={onSubmitText}
              cancelText={t('cancel')}
            >
              <ButtonModal
                type="primary"
                htmlType="button"
                onClick={() => onSubmit()}
                disabled={disabledSubmit}
              >{onSubmitText || t('ok')}
              </ButtonModal>
            </Popconfirm>
          </ConfigProvider>
        </div>
      )
    }
    if (loadingSubmit) {
      return (
        <Spin spinning={isLoadingSubmit} wrapperClassName="button">
          <ButtonModal
            type="primary"
            htmlType="button"
            disabled={disabledSubmit}
            onClick={() => onSubmit()}
          >
            {onSubmitText || t('ok')}
          </ButtonModal>
        </Spin>
      )
    }
    return (
      <>
        {submit && (
        <ButtonModal
          type="primary"
          htmlType="button"
          disabled={disabledSubmit}
          onClick={() => onSubmit()}
        >
          {onSubmitText || t('ok')}
        </ButtonModal>
        )}
      </>
    )
  }

  return (
    <ModalWrapper
      isOpen={visible}
      onRequestClose={onClose}
      style={overlay ? customStyles : ''}
      ariaHideApp={false}
      className={themeMode}
      modalWith={modalWith}
      {...rest}
    >
      <form>
        <div className="ant-modal-content">
          <div className="ant-modal-header">
            {
              showCloseButton && (
                <button className="ant-modal-close" onClick={onClose || onCancel} type="button">
                  <div className="ant-modal-close-x">
                    <div className="anticon anticon-close ant-modal-close-icon">
                      {
                        showCloseText && <span>{t('create.close')}</span>
                      }
                      <CloseOutlined />
                    </div>
                  </div>
                </button>
              )
            }

            {title && (
              <HeaderContentStyled>
                &nbsp;
                {title}
              </HeaderContentStyled>
            )}
          </div>
          <div className="ant-modal-body">{renderModalBodyBaseOnType()}</div>

          {!isNotFooterButton && (
            <div className={`ant-modal-footer ${!cancel ? 'no-cancel-button' : ''}`}>
              {cancel && (
                <ButtonModal type="cancel" onClick={onCancel} className="ant-btn button__cancel">
                  <span>{onCancelText || t('cancel')}</span>
                </ButtonModal>
              )}
              {renderButtonSubmit()}
            </div>
          )}
        </div>
      </form>
    </ModalWrapper>
  )
}

export default ModalComponent
